import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function bankingOTPSend(token, params){

    return Api.post(REQUEST_URLS.FIN_CHECK.BANKING_OTP_SEND,params,{
        headers:{
            'Authorization': 'Bearer ' + token
        }
    })
}
export default bankingOTPSend;